module.exports = __webpack_public_path__ + "img/feature-work-2-large.5b9448e0.jpg";